import React from 'react';

const UserMediaRow = ({ title, userMedias = [], containerId }) => {
    const [modalState, setModalState] = React.useState({ isOpen: false, userIndex: null, mediaIndex: 0 });

    const openUserModal = (userIndex) => setModalState({ isOpen: true, userIndex, mediaIndex: 0 });
    const closeModal = () => setModalState({ isOpen: false, userIndex: null, mediaIndex: 0 });

    const goToPrev = () => {
        const currentUser = userMedias[modalState.userIndex];
        if (!currentUser) return;
        const total = currentUser.media.length;
        setModalState((s) => ({ ...s, mediaIndex: (s.mediaIndex - 1 + total) % total }));
    };

    const goToNext = () => {
        const currentUser = userMedias[modalState.userIndex];
        if (!currentUser) return;
        const total = currentUser.media.length;
        setModalState((s) => ({ ...s, mediaIndex: (s.mediaIndex + 1) % total }));
    };

    const renderMediaThumb = (mediaItem) => {
        if (!mediaItem) return null;
        if (mediaItem.type === 'video') {
            return (
                <div className="relative w-full h-full bg-black">
                    <video src={mediaItem.url} poster={mediaItem.thumbnail || ''} controls className="w-full h-full object-cover" />

                    <div className="absolute inset-0 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                            <rect x="0.796875" width="28" height="28" rx="2" fill="#4D4D4D" />
                            <path d="M8.79688 22V6L21.7969 14L8.79688 22Z" fill="white" />
                        </svg>


                    </div>
                </div>
            );
        }
        return <img src={mediaItem.url} alt={mediaItem.caption || 'Image'} className="w-full h-full object-contain" />;
    };

    if (!userMedias || userMedias.length === 0) return null;

    return (
        <div className="w-full mt-3 relative">
            {/* Left Arrow */}
            <button
                aria-label="scroll-left"
                className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-neutral50C rounded-full shadow flex items-center justify-center hover:bg-neutral50D"
                onClick={() => {
                    const el = document.getElementById(`user-media-row-${containerId}`);
                    if (el) el.scrollBy({ left: -280, behavior: 'smooth' });
                }}
            >
                <svg className="w-4 h-4 text-textSecondary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
            </button>

            {/* Right Arrow */}
            <button
                aria-label="scroll-right"
                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-8 h-8 bg-neutral50C rounded-full shadow flex items-center justify-center hover:bg-neutral50D"
                onClick={() => {
                    const el = document.getElementById(`user-media-row-${containerId}`);
                    if (el) el.scrollBy({ left: 280, behavior: 'smooth' });
                }}
            >
                <svg className="w-4 h-4 text-textSecondary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
            </button>

            {/* Cards */}
            <div id={`user-media-row-${containerId}`} className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide px-10">
                {userMedias.map((user, idx) => {
                    const firstMedia = user.media?.[0];
                    const hasMultiple = (user.media?.length || 0) > 1;
                    return (
                        <div key={`${user.uid}-${idx}`} className="relative flex-shrink-0 w-[20.5rem] h-[12.875rem] rounded-lg overflow-hidden shadow-custom-multi-small">
                            <button className="relative w-full h-full" onClick={() => openUserModal(idx)}>
                                <div className="absolute inset-0">
                                    {renderMediaThumb(firstMedia)}
                                </div>
                                {hasMultiple && (

                                    <div className='absolute top-0 left-0 right-0 bg-media-gradient py-2 px-3   '>
                                        <div className='flex items-center justify-end '>
                                            <div className='flex items-center gap-1'>
                                                <span className=" text-white text-end text-xs  rounded">View more</span>
                                                <div className='bg-[#414141] p-1 rounded-sm '>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                        <path d="M3.73811 9.76379V8.70496H1.83752L4.21987 6.32261L3.4734 5.57614L1.09105 7.95849V6.0579H0.0322266V9.76379H3.73811ZM6.12046 4.42202L8.50281 2.03967V3.94026H9.56164V0.234375H5.85576V1.2932H7.75634L5.37399 3.67555L6.12046 4.42202Z" fill="white" />
                                                    </svg>
                                                </div>

                                            </div>
                                        </div>


                                    </div>
                                )}
                                <div className="absolute inset-x-0 bottom-0 pt-[1.125rem] px-3 pb-2 bg-media-gradient-bottom flex items-center justify-between">
                                    <span className="text-white text-xs">{user.impactPointsRewarded} IP</span>
                                    <div className="flex items-center gap-2">
                                        <img src={user.profileImage} alt={user.username} className="w-5 h-5 rounded-full object-cover" />
                                        <span className=" text-white text-xs ">{user.username}</span>
                                    </div>
                                </div>
                            </button>
                        </div>
                    );
                })}
            </div>

            {/* Modal */}
            {modalState.isOpen && modalState.userIndex !== null && (() => {
                const selectedUser = userMedias[modalState.userIndex];
                const items = selectedUser?.media || [];
                const current = items[modalState.mediaIndex];
                const canNavigate = items.length > 1;
                return (
                    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] p-4" onClick={closeModal}>
                        <div className="bg-grayBgNormal rounded-lg  flex flex-col" onClick={(e) => e.stopPropagation()}>
                            <div className="flex justify-between items-start px-6 pt-5 ">
                                <div className="flex flex-col">
                                    <h3 className="text-2xl font-medium text-textPrimary truncate">{title}</h3>
                                </div>
                                <button onClick={closeModal} className="text-textPrimary bg-neutral50C rounded-full p-2 hover:bg-neutral50D ">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>
                            <div className='flex px-6 pt-4 pb-2 items-center justify-between'>

                                <div>
                                    <div className="text-xs text-textSecondary font-semibold">Data Points</div>
                                    <div className='mt-1'>
                                        <div className="text-sm text-textSecondary truncate max-w-[28rem]">
                                            {(current?.actions || []).map(a => a?.value).filter(Boolean).join(' • ') || '—'}
                                        </div>
                                    </div>

                                </div>


                                <div>
                                    <div className=" text-xs text-textSecondary font-semibold ">Response Type</div>
                                    <div className='mt-1'>
                                        <div className="text-sm  text-textSecondary capitalize">{current?.actionType?.replaceAll('_', ' ')?.toLowerCase() || 'Media'}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="relative flex items-center justify-center py-4 px-6">
                                {canNavigate && (
                                    <button onClick={goToPrev} className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-neutral50C hover:bg-neutral50D rounded-full shadow flex items-center justify-center">
                                        <svg className="w-5 h-5 text-textSecondary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                                    </button>
                                )}
                                <div className="w-[54.6875rem] flex items-center justify-center">
                                    {current?.type === 'video' ? (
                                        <video src={current.url} poster={current.thumbnail || ''} controls className="w-[54.6875rem] h-[26.3125rem] lg:h-[31.3125rem] object-contain rounded-lg bg-black" />
                                    ) : (
                                        <img src={current?.url} alt={current?.caption || 'Image'} className="w-[54.6875rem] h-[26.3125rem] lg:h-[31.3125rem] object-contain rounded-lg" />
                                    )}
                                </div>
                                {canNavigate && (
                                    <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-neutral50C rounded-full shadow flex items-center hover:bg-neutral50D justify-center">
                                        <svg className="w-5 h-5 text-textSecondary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                                    </button>
                                )}
                            </div>
                            <div className="flex items-center justify-center py-2">
                                <div className="flex gap-2">
                                    {items.map((_, i) => (
                                        <button key={i} onClick={() => setModalState(s => ({ ...s, mediaIndex: i }))} className={`w-2.5 h-2.5 rounded-full ${i === modalState.mediaIndex ? 'bg-gray-600' : 'bg-gray-300'}`} />
                                    ))}
                                </div>
                            </div>
                            <div className="flex items-center justify-between px-6 pb-5">
                                <span className="text-sm text-textSecondary font-medium">{current?.impactPoints} IP</span>
                                <div className="flex items-center gap-2">
                                    <img src={selectedUser.profileImage} alt={selectedUser.username} className="w-5 h-5 rounded-full object-cover" />
                                    <span className="text-sm text-textSecondary">{selectedUser.username}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })()}
        </div>
    );
};

export default UserMediaRow; 